import { useQuery } from '@tanstack/react-query';
import { transactionsService } from 'commons/services';
import { DateRangeType, Sort, TransactionStatusType } from 'commons/types';

interface TransactionsQueryParams {
  page: number;
  search?: string;
  status?: string | TransactionStatusType[];
  dateRange?: DateRangeType;
  fromDate?: string;
  toDate?: string;
  hasChargeback?: boolean;
  items?: number;
  sort?: Sort;
}

export function useTransactionsQuery({
  page,
  search,
  status,
  dateRange,
  fromDate,
  toDate,
  hasChargeback,
  items,
  sort,
}: TransactionsQueryParams) {
  const processedStatus = Array.isArray(status) ? status.join(',') : status;

  const queryResult = useQuery(['transactionsQuery', processedStatus], () =>
    transactionsService.getTransactions({
      page,
      search,
      status: processedStatus,
      dateRange,
      fromDate,
      toDate,
      hasChargeback,
      items,
      sort,
    }),
  );

  const hasTransactions =
    queryResult.data?.itemsCount && queryResult.data.itemsCount > 0;

  return {
    ...queryResult,
    hasTransactions,
  };
}
